import moment from 'moment'

export function formatDate(value: Date | undefined) {
  if (value === undefined) {
    return moment(Date.now()).format('YYYY-MM-DD')
  }
  return moment(value).format('YYYY-MM-DD')
}

export function parseDate(value: string | undefined): Date | undefined {
  if (value === undefined) {
    return undefined
  }
  return moment(value, 'YYYY-MM-DD').toDate()
}

export function formatTime(value: Date | undefined) {
  if (value === undefined) {
    return moment(Date.now()).format('YYYY-MM-DD HH:mm')
  }
  return moment(value).format('HH:mm')
}

export function formatDateTime(value: Date | undefined) {
  if (value === undefined) {
    return moment(Date.now()).format('YYYY-MM-DD HH:mm')
  }
  return moment(value).format('YYYY-MM-DD HH:mm')
}

export function formatDateRange(startDate: Date, endDate: Date) {
  if (startDate === undefined && endDate === undefined) {
    return null
  }

  return `${formatDate(startDate)} - ${formatDate(endDate)}`
}
